export default __webpack_public_path__ + "static/media/redux.c120994a.png";